<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model="tenantUserId" placeholder="accountId" clearable size="mini" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="auditStatus" placeholder="审核状态" clearable size="mini">
                <el-option v-for="opt in auditStatusArr" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="clearFilters">重置</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch({ page: 1 })">查询</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tableData" height="500" v-loading="listLoading">
        <el-table-column label="审核ID" prop="id" align="center" />
        <el-table-column label="用户ID" prop="tenantUserId" align="center" />
        <el-table-column label="头像" align="center" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.headPortrait" :src="scope.row.headPortrait" class="avatar" alt="" />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称" prop="nickname" align="center" />
        <el-table-column label="修改内容" prop="changeDesc" width="150" align="center" />
        <el-table-column label="审核状态" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ formatAuditStatus(scope.row) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="审核时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.updateTime || scope.row.updatedTime) | moment }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.createTime || scope.row.createdTime) | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="$hasPerm('tenant:audit_official_avatar:audit') && canAudit(scope.row)"
              type="text"
              size="mini"
              @click="openAudit(scope.row)"
            >{{ auditButtonText(scope.row) }}</el-button>
            <el-button v-if="$hasPerm('tenant:audit_official_avatar:open_audit_log')" type="text" size="mini"
              @click="openAuditLog(scope.row)">审核记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination :size="pagination.size" :total="total" :page="pagination.page" @pageChanged="onPageChange" />

      <el-dialog :title="isReaudit ? '重新审核' : '审核'" :visible.sync="auditVisible" width="480px"
        :destroy-on-close="true">
        <div class="audit-info">
          <div class="row">
            <span class="label">昵称：</span>
            <span class="value">{{ currentRow.nickname || "--" }}</span>
          </div>
          <div class="row avatar-row">
            <span class="label">头像：</span>
            <template v-if="currentRow.headPortrait">
              <el-image class="avatar-large" :src="currentRow.headPortrait"
                :preview-src-list="[currentRow.headPortrait]" fit="cover" />
            </template>
            <span v-else>--</span>
          </div>
        </div>
        <el-form :model="auditForm" label-width="90px" class="audit-form">
          <el-form-item label="审核结果" required>
            <el-select v-model="auditForm.auditStatus" placeholder="请选择" size="small">
              <el-option v-for="opt in auditResultOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="拒绝原因" :required="isRejectResult">
            <el-input v-model="auditForm.rejectReason" type="textarea" :rows="3" maxlength="200" show-word-limit
              :placeholder="isRejectResult ? '请输入拒绝原因' : '审核通过时无需填写'" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="auditVisible = false">取消</el-button>
          <el-button v-if="$hasPerm('tenant:audit_official_avatar:audit')" type="primary" :loading="submitLoading"
            @click="handleAuditSubmit">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="审核记录" :visible.sync="auditLogVisible" width="920px" :destroy-on-close="true">
        <el-table :data="auditLogList" v-loading="auditLogLoading">
          <el-table-column prop="id" label="审核id" align="center" width="120" />
          <el-table-column prop="changeDesc" label="修改内容" align="center" width="120" />
          <el-table-column prop="auditStatus" label="审核状态" align="center" width="220">
            <template slot-scope="scope">
              <span>{{ formatAuditStatus(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拒绝原因" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.rejectReason || scope.row.reason || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核时间" align="center" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.auditTime | moment }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核人员id" align="center" width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.auditorId || scope.row.operatorId || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="auditLogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  name: "OfficialAvatarNicknameAudit",
  components: {
    Pagination,
  },
  data() {
    return {
      tenantUserId: "",
      auditStatus: "",
      auditStatusArr: [
        { label: "全部状态", value: "" },
        { label: "待审核", value: 0 },
        { label: "审核通过", value: 1 },
        { label: "审核拒绝", value: 2 },
        { label: "仅昵称通过/头像拒绝", value: 3 },
        { label: "仅头像通过/昵称拒绝", value: 4 },
      ],
      auditResultOptions: [
        { label: "审核通过", value: 1 },
        { label: "审核拒绝", value: 2 },
        { label: "仅昵称通过/头像拒绝", value: 3 },
        { label: "仅头像通过/昵称拒绝", value: 4 },
      ],
      tableData: [],
      total: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      listLoading: false,
      auditVisible: false,
      currentRow: {},
      auditForm: {
        id: "",
        auditStatus: 0,
        rejectReason: "",
      },
      submitLoading: false,
      auditLogVisible: false,
      auditLogLoading: false,
      auditLogList: [],
    };
  },
  mounted() {
    this.fetchList();
  },
  computed: {
    isReaudit() {
      return String(this.currentRow.auditStatus) === "1";
    },
    isRejectResult() {
      return [2, 3, 4].includes(Number(this.auditForm.auditStatus));
    },
  },
  methods: {
    canAudit(row) {
      return ["0", "1"].includes(String(row.auditStatus));
    },
    auditButtonText(row) {
      return String(row.auditStatus) === "1" ? "重新审核" : "审核";
    },
    formatAuditStatus(row) {
      const value = row.auditStatus !== undefined && row.auditStatus !== null ? row.auditStatus : row.status;
      if (String(value) === "0") return "待审核";
      if (String(value) === "1") return "审核通过";
      if (String(value) === "2") return "审核拒绝";
      if (String(value) === "3") return "仅昵称通过/头像拒绝";
      if (String(value) === "4") return "仅头像通过/昵称拒绝";
      return value === undefined || value === null || value === "" ? "--" : String(value);
    },
    fetchList(extra = {}) {
      if (this.listLoading) return;
      this.listLoading = true;
      api
        .getLeaderAuditList({
          tenantUserId: this.tenantUserId,
          auditStatus: this.auditStatus,
          ...this.pagination,
          ...extra,
        })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            const { list = [], totalCount, total } = res.data || {};
            this.tableData = list;
            this.total = totalCount !== undefined ? totalCount : (total || 0);
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleSearch(extra = {}) {
      this.pagination.page = extra.page || 1;
      this.fetchList();
    },
    clearFilters() {
      this.tenantUserId = "";
      this.auditStatus = "";
      this.handleSearch({ page: 1 });
    },
    onPageChange(pagination) {
      this.pagination = pagination;
      this.fetchList();
    },
    openAudit(row) {
      this.currentRow = row || {};
      this.auditForm = {
        id: row.id,
        auditStatus: 1,
        rejectReason: "",
      };
      this.auditVisible = true;
    },
    handleAuditSubmit() {
      if (!this.auditForm.id) {
        this.$message.warning("缺少审核ID，无法提交");
        return;
      }
      const rejectReason = String(this.auditForm.rejectReason || "").trim();
      if (this.isRejectResult && !rejectReason) {
        this.$message.warning("请填写拒绝原因");
        return;
      }
      if (this.submitLoading) return;
      const submit = () => {
        const payload = {
          id: this.auditForm.id,
          auditStatus: this.auditForm.auditStatus,
        };
        if (this.isRejectResult) {
          payload.rejectReason = rejectReason;
        }
        this.submitLoading = true;
        api
          .getLeaderProfileAudit(payload)
          .then((res) => {
            if (res && res.code === 0) {
              this.$message.success(this.isReaudit ? "重新审核成功" : "审核提交成功");
              this.auditVisible = false;
              this.fetchList();
            } else {
              this.$message.error((res && (res.msg || res.message)) || "审核提交失败");
            }
          })
          .catch(() => {
            this.$message.error("审核提交失败，请稍后重试");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      };
      if (this.isRejectResult) {
        this.$confirm(
          "拒绝后已生效资料将立即恢复为系统默认值，是否继续？",
          "提示",
          { type: "warning" }
        ).then(submit).catch(() => {});
        return;
      }
      submit();
    },
    openAuditLog(row) {
      const id = row && (row.id || row.leaderId || row.applyId);
      if (!id) {
        this.$message.warning("缺少审核ID，无法获取记录");
        return;
      }
      this.auditLogVisible = true;
      this.auditLogLoading = true;
      this.auditLogList = [];
      api
        .getLeaderProfileAuditRecord({ id })
        .then((res) => {
          if (res && res.code === 0) {
            this.auditLogList = Array.isArray(res.data) ? res.data : (res.data && res.data.items) || [];
          } else {
            this.$message.error((res && res.message) || "获取审核记录失败");
          }
        })
        .catch(() => {
          this.$message.error("获取审核记录失败，请稍后重试");
        })
        .finally(() => {
          this.auditLogLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.page-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.select {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.item {
  margin-right: 12px;
  margin-bottom: 8px;
}

.audit-info {
  .row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .label {
    width: 70px;
    color: #666;
  }

  .value {
    color: #333;
  }

  .avatar-large {
    width: 120px;
    height: 120px;
    border-radius: 6px;
    object-fit: cover;
  }
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.audit-form {
  margin-top: 8px;
}
</style>
